<template>
<div>
  
                        
      <div class="rounded-lg shadow border border-white bg-white">
            <div class="row justify-content-centre align-items-center">   

                            <h4 class="col ml-3 font-weight-lighter text-info"> <span class="fa fa-user-tag"></span> Gestion Des Vendeurs </h4> 

            <div class="col">
                
                <b-button pill size="sm"  class="pt-2 mt-2 mr-2 float-right text-secondary" variant="link" @click="NewBon">
                            <i class="fa fa-home fa-2x"></i>
                 </b-button>
                <b-button pill size="sm"  class="m-3 float-right" variant="success" @click="add_click($event.target)">
                            <i class="fa fa-plus-square"></i>
                    <span> Ajouter</span> 
                </b-button>

                <b-button pill size="sm"  class="m-3 float-right" variant="info" @click="fetchList">
                    <i class="fa fa-sync-alt"></i>
                    <span> Actualiser</span> 
                </b-button>
            </div>
            </div>
       



        <b-table 
        sort-icon-left
        head-variant="light"
        responsive 
        :fields="fields" 
        :items="itemslist"
        >
            <template #cell(actions)="row">
                    <b-button pill size="sm"  class="mr-2 mt-1 mb-1 float-right" variant="outline-danger" @click="del_click(row.item)">
                                <i class="fa fa-trash-alt"></i>
                        
                    </b-button>
                    <b-button pill size="sm" class="mr-2 mt-1 mb-1 float-right" variant="outline-primary" @click="edit_click(row.item, row.index, $event.target)">
                            <i class="fa fa-pencil-alt"></i>
                    
                    </b-button>
                </template>
        
        </b-table>
      </div>


    <!-- le modal -->
    <b-modal id="banqModal" :title="itemForm.nom_prenom"  hide-footer>
           <form @submit.prevent="handleSubmit">
            <div class="form-group">
                <label for="code">Code Vendeur</label>
                <input type="text" v-model="itemForm.code" id="code" name="code" class="form-control"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.code.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.code.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
            </div>


            <div class="form-group">
                <label for="nom_prenom">Nom et Prénom</label>
                <input type="text" v-model="itemForm.nom_prenom" id="name" name="nom_prenom" class="form-control"
                    :class="{ 'is-invalid': isSubmitted && $v.itemForm.nom_prenom.$error }" />
                <div v-if="isSubmitted && !$v.itemForm.nom_prenom.required" class="invalid-feedback">Ce champ est obligatoire !!</div>
            </div>

            <div class="form-group">
                <label for="tel">Téléphone </label>
                <input type="text" v-model="itemForm.tel" id="tel" name="tel" class="form-control" />

            </div>
            <div class="form-group">
            <label for="Description">Adresse</label>
            <textarea name="description" id="description"  rows="4" class="form-control" v-model="itemForm.adresse"></textarea>

            </div>


            <div class="custom-control custom-switch">
            <input type="checkbox"
             class="custom-control-input" 
             id="etat"
                    v-model="itemForm.etat"
                    name="etat"
                    value=true
                    unchecked-value=false

             >

            <label class="custom-control-label" for="etat">Actif</label>
            </div>

            <div class="form-group">
                <button type="submit" class="btn  btn-primary btn-block">{{ModalType}}</button>
            </div>


        </form>
    </b-modal>


    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#0179F9" loader='bars'></loading>


</div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import {required} from "vuelidate/lib/validators";

export default {

    mounted(){
        this.fetchList()
    
    },
	data () {
		return {
            itemslist: [],
            zones:[],
            itemForm: {
                    id:'',
                    code:'',
                    nom_prenom:'',
                    tel:'',
                    etat:true,
                    adresse:''},
            fields: [
                {key: 'code', label: 'Code/ID', sortable: true},
                {key: 'nom_prenom', label: 'Nom et Prénom', sortable: true},
                {key: 'tel', label: 'Téléphone', sortable: true},
                {key: 'adresse', label: 'Adresse', sortable: true},
                {key: 'etat', label: 'Actif', 
                formatter: (value) => {
                 return value ? 'Oui' : 'Non'
                }, sortable: true},
                { key: 'actions', label: '' }
            ],
            //public trucs
            ModalEdit: false,
            ModalType:'Ajouter',
            isSubmitted: false,
            isLoading: false
		}
	},
    validations: {
            itemForm: {
                code: {
                    required
                },
               nom_prenom: {
                    required
                },
                etat: {
                    required
                }
            }
    },
    methods :{


        itemslisttore(){
                        this.isLoading=true;

            this.$http.post('/vendeurs',{
            code:this.itemForm.code,
            nom_prenom:this.itemForm.nom_prenom,
            tel:this.itemForm.tel,
            adresse:this.itemForm.adresse,
            etat:this.itemForm.etat


                })
                .then(response => {

                    this.isLoading=false;
                    this.itemslist.unshift(response.data.data);
                    this.$bvModal.hide('banqModal')

                    //afficher message
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données sauvegardées',
                    message: 'Les données sont sauvegardées correctement '
                })


                })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Sauvegarde',
                message: 'Impossible  de sauvegarder les données .. Réessayez !!'
                })
                });

        },
        banqueEdit(){

            this.isLoading=true;

            this.$http.patch('/vendeurs/'+this.itemForm.id,{
            code:this.itemForm.code,
            nom_prenom:this.itemForm.nom_prenom,
            tel:this.itemForm.tel,
            adresse:this.itemForm.adresse,
            etat:this.itemForm.etat

                })
                .then(response => {

                    this.isLoading=false;
                    console.log(response.data)
                    this.$bvModal.hide('banqModal')

                    let index = this.itemslist.findIndex(item => item.id === this.itemForm.id)
                    this.itemslist.splice(index, 1,response.data.data)
                    
                    this.flashMessage.show({
                    status: 'success',
                    title: 'Données modifiées',
                    message: 'Les données sont modifiées correctement'
                    })


                    })
                    .catch(error=> {console.log(error)
                    this.isLoading=false;


                    this.flashMessage.show({
                    status: 'error',
                    title: 'Erreur De Modification',
                    message: 'Impossible  de modifier les données .. Réessayez !!'
                })
                });

        },
        banqueDell(){

            this.isLoading=true;

            this.$http.delete('/vendeurs/'+this.itemForm.id)
                .then(response => {
                console.log(response.data)
                    this.isLoading=false;



                    
                this.flashMessage.show({
                status: 'success',
                title: 'Données Supprimées',
                message: 'Les données sont supprimées correctement'
                })


                    let index = this.itemslist.findIndex(item => item.id === this.itemForm.id)
                    this.itemslist.splice(index, 1)




                    })
                .catch(error=> {console.log(error)
                this.isLoading=false;


                this.flashMessage.show({
                status: 'error',
                title: 'Erreur De Suppression',
                message: 'Impossible  de supprimer les données .. Réessayez !!'
                })
                });

        },
        add_click(button) {
        this.itemForm.id=''
        this.itemForm.code=''
        this.itemForm.nom_prenom=''
        this.itemForm.tel=''
        this.itemForm.adresse=''
        this.itemForm.etat=true



        this.ModalEdit=false;
        this.ModalType='Ajouter'








        this.$root.$emit('bv::show::modal', 'banqModal', button)
      },
        edit_click(item, index, button) {

                this.$confirm("Voulez-vous vraiment modifier cet élément ??")
                 .then(() => {

        this.itemForm.id=item.id
        this.itemForm.code=item.code
        this.itemForm.nom_prenom=item.nom_prenom
        this.itemForm.tel=item.tel
        this.itemForm.adresse=item.adresse
        this.itemForm.etat=item.etat






                this.ModalEdit=true;
                this.ModalType='Modifier'

                this.$root.$emit('bv::show::modal', 'banqModal', button)
                })
                .catch(error=> {
                console.log(error)

                });


      },
        del_click(item) {

                this.$confirm("Voulez-vous vraiment supprimer cet élément ??")
                 .then(() => {
 
        this.itemForm.id=item.id
        this.itemForm.code=item.code
        this.itemForm.nom_prenom=item.nom_prenom
        this.itemForm.tel=item.tel
        this.itemForm.adresse=item.adresse
        this.itemForm.etat=item.etat


                                    this.banqueDell()
                                })
                                .catch(error=> {
                                console.log(error)

                                    });




      },
        fetchList: function () {
                    this.isLoading=true;
                    this.$http.get('/vendeurs')
                    .then((result) => {
                                this.itemslist = result.data.data
                                this.isLoading=false;
                    })
                    .catch(error=> {
                                console.log(error)
                                this.isLoading=false;
                                this.flashMessage.show({
                                status: 'error',
                                title: 'Erreur de Chargement',
                                message: 'Impossible charger les données.. Actualisez et Réessayez'
                                })
                    });
        },
        handleSubmit() {
                this.isSubmitted = true;

                this.$v.$touch();
                if (this.$v.$invalid) {
                this.flashMessage.show({
                status: 'info',
                title: 'Vérifiez les données et Reésayez !!',
                })
                }
                else 
                {


                            if(this.ModalEdit)
                            {
                                this.banqueEdit()
                            }
                            else
                            {

                                this.itemslisttore()
                            }   

                }

            },
        NewBon()
        {
                    this.$router.push({ 
                        name: 'menuClientVend'
                    });
        },

    },
    components: {
              Loading      
    }
}
</script>

<style  scoped>

</style>